import HoraireColDisplay from "./HoraireColDisplay.tsx";
import { days, dayToJour, HorairesDTO } from "cadendar-shared";

interface HoraireDisplayProps {
  horaire: HorairesDTO;
}

const HoraireDisplay = (props: HoraireDisplayProps) => {
  const { horaire } = props;
  return (
    <div className="w-full" key={horaire.owner + horaire.date.toString()}>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(160px,1fr))] gap-4 max-sm:grid-cols-1">
        {days.map((day) => (
          <div
            className="flex h-full flex-col rounded-2xl border border-[var(--color-grey)] bg-[#fbfcff] p-4"
            key={day + "horaireKey"}
          >
            <div className="mb-3 text-center font-bold text-[var(--color-darker-blue)]">
              {dayToJour(day)}
            </div>
            <HoraireColDisplay plages={horaire.horaire[day]} jour={day} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HoraireDisplay;
